import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ProductsEffects } from './products.effects';
import { STORE_TYPE } from './products.model';
import { productsReducer } from './products.reducer';

export const UIProductsStoreModule = [
  StoreModule.forFeature(STORE_TYPE, productsReducer),
  EffectsModule.forFeature([ProductsEffects]),
];